import { motion } from 'framer-motion';

export default function Privacy() {
  return (
    <div className="min-h-screen pt-16">
      <section className="py-24 bg-gradient-to-br from-night-900 via-night-800 to-night-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-5xl font-bold mb-6">
              <span className="bg-gradient-to-r from-launch-blue via-launch-purple to-launch-orange bg-clip-text text-transparent">
                Privacy Policy
              </span>
            </h1>
            <p className="text-offwhite/60">Last updated: {new Date().toLocaleDateString()}</p>
          </motion.div>
        </div>
      </section>

      <section className="py-16 bg-night-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-invert prose-launch max-w-none">
            <div className="space-y-8 text-offwhite/80">
              <div>
                <h2 className="text-2xl font-bold text-offwhite mb-4">1. Information We Collect</h2>
                <p>
                  We collect information that you provide directly to us, including when you contact us 
                  through our website, request information about our services, or engage with us for 
                  technical support or development services.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-offwhite mb-4">2. How We Use Your Information</h2>
                <p>We use the information we collect to:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Provide, maintain, and improve our services</li>
                  <li>Respond to your inquiries and fulfill your requests</li>
                  <li>Send you technical notices and support messages</li>
                  <li>Communicate with you about products, services, and events</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-offwhite mb-4">3. Information Sharing</h2>
                <p>
                  We do not sell, trade, or otherwise transfer your personal information to third parties 
                  without your consent, except as required by law or as necessary to provide our services.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-offwhite mb-4">4. Data Security</h2>
                <p>
                  We implement appropriate technical and organizational measures to protect your personal 
                  information against unauthorized access, alteration, disclosure, or destruction.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-offwhite mb-4">5. Your Rights</h2>
                <p>You have the right to:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Access your personal information</li>
                  <li>Correct inaccurate data</li>
                  <li>Request deletion of your data</li>
                  <li>Object to processing of your data</li>
                  <li>Request data portability</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-offwhite mb-4">6. Contact Us</h2>
                <p>
                  If you have any questions about this Privacy Policy, please contact us at:
                  <br />
                  <a href="mailto:privacy@cloudlaunch.com" className="text-launch-blue hover:text-launch-purple">
                    privacy@cloudlaunch.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
